<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'JsonDataRenderer',
  mixins: [baseMixin],
  props: {
    json: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    activeTab: 0,
  }),
  methods: {
    formatLabel(key) {
      return this.formatCamelCaseString(key)
    },
    formatTabName(name) {
      return this.formatCamelCaseString(name)
    },
    formatCamelCaseString(text) {
      return String(text)
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, (str) => str.toUpperCase())
    },
    isPrimitive(value) {
      return value !== Object(value)
    },
  },
}
</script>

<template>
  <div>
    <v-tabs v-model="activeTab" background-color="primary" dark>
      <v-tab v-for="(value, tabName) in json" :key="tabName">
        {{ formatTabName(tabName) }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="activeTab">
      <v-tab-item v-for="(value, tabName) in json" :key="tabName">
        <v-card flat>
          <v-card-text>
            <v-form>
              <v-row>
                <!-- If primitive, show single field -->
                <v-col v-if="isPrimitive(value)" cols="12">
                  <v-text-field
                    :label="formatLabel(tabName)"
                    :value="value"
                    readonly
                  ></v-text-field>
                </v-col>

                <!-- If object, iterate through fields -->
                <template v-else>
                  <v-col
                    v-for="(fieldValue, key) in value"
                    :key="key"
                    cols="12"
                    sm="6"
                  >
                    <v-text-field
                      :label="formatLabel(key)"
                      :value="fieldValue"
                      readonly
                    ></v-text-field>
                  </v-col>
                </template>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
